<template>
  <div class="outterClass" @contextmenu="handler($event)">
    <div>
        <el-button type="primary" @click="print()">Print</el-button>
        <el-button type="primary" @click="onZoomIn()">ZoomIn</el-button>
        <el-button type="primary" @click="onZoomOut()">ZoomOut</el-button>
        <span>
            Page: <span id="page_num"></span> / <span id="page_count">{{gettotalPageCount}}</span>
        </span> 
    </div>
	<div class="documentArea" v-if="show">
        <div id="printArea">
            <PdfPage ref="myPdfComponent" v-for="(page, index) in getPdfPages" v-bind:key="index" v-bind:page="page"  v-bind:scale = "getScale" v-bind:id_num="index"/>
        </div>
    </div>
    <div v-else>Wait for render</div>
  </div> 
</template>
<script>

import { mapGetters } from "vuex";
import PdfPage from './PdfPage.vue' 

export default {
  name: 'PDF',
  components: {
    PdfPage
  },
  mounted() {
  //get the pdf binary data from server as json
    // this.$store.dispatch('communication_pdf/getPDFS')
    //   .then(() => {
        var urls = this.getPdfName;
        console.log("pdfDocs ======"+urls);
        this.$store.dispatch('communication_pdf/getPdfDocs',urls).then(() => {
            var pdfDocs = this.getPdfDocs;
            console.log("pdfDocs ======"+pdfDocs.length);
            this.$store.dispatch('communication_pdf/getPdfPages',pdfDocs).then(() => {
                var pdfPages = this.getPdfPages;
                console.log("pdfPages ======"+pdfPages.length);
                this.show = true;
            })
        })
        
      // })
      // .catch(() => console.log("pdf Loading Error"));
  },
  methods: {
    onZoomIn(){
        this.$store.dispatch('communication_pdf/zoomIn')
    },
    onZoomOut(){
        this.$store.dispatch('communication_pdf/zoomOut')
    },
    print(){
        window.print();
    }
  },
  computed: {
    ...mapGetters("situation0004",["getPdfdocs","getPdfName","getPdfPages","getScale","gettotalPageCount"])
  },
  data () {
    return {
      show: false
    }
  } 
};
</script>
<style scoped>
  .outterClass{
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
  
  .documentArea{
    position: fixed;
    overflow: scroll;
    width: 100%;
    height: 90%;
  
  }
@media print {
  body * {
    visibility: hidden;
  }
  .documentArea{
    position: relative !important;   
    height: auto !important;
  
  }
  #printArea, #printArea * {
    visibility: visible;
  }
  
}

</style>